export default function ComparisonSection() {
  return (
    <section className="py-20 md:py-28 px-6 md:px-10 bg-secondary-100">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-14">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-4">
            OOPBuy Vergleich: Mit vs. Ohne Spreadsheet
          </h2>
          <p className="text-foreground-500 text-base max-w-xl mx-auto">
            Ein strukturiertes OOPBuy Spreadsheet macht den entscheidenden Unterschied bei der
            Produktsuche und gibt dir einen klaren Vorteil.
          </p>
        </div>

        <div className="overflow-hidden rounded-xl border border-background-200/70 bg-background-50">
          <table className="w-full">
            <thead>
              <tr className="border-b border-background-200/70">
                <th className="px-6 py-4 text-left text-sm font-semibold text-foreground-500 w-1/2">
                  Ohne Spreadsheet
                </th>
                <th className="px-6 py-4 text-left text-sm font-semibold text-accent-700 bg-accent-50/50 w-1/2">
                  Mit OOPBuy Spreadsheet
                </th>
              </tr>
            </thead>
            <tbody>
              {[
                ['Lange Suche nach Produkten', 'Schneller Überblick über alle Kategorien'],
                ['Unsortierte und unübersichtliche Ergebnisse', 'Strukturierte und sortierte Kategorien'],
                ['Schwieriger Preis- und Produktvergleich', 'Einfacher und direkter Vergleich'],
                ['Kompliziert für Einsteiger und Anfänger', 'Einfach erklärt und intuitiv bedienbar'],
              ].map((row, idx) => (
                <tr key={idx} className="border-b border-background-200/70 last:border-b-0">
                  <td className="px-6 py-4 text-sm text-foreground-500">{row[0]}</td>
                  <td className="px-6 py-4 text-sm text-foreground-900 font-medium bg-accent-50/30">
                    <span className="inline-flex items-center gap-2">
                      <i className="ri-check-line text-accent-600 text-base"></i>
                      {row[1]}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="mt-12 overflow-hidden rounded-xl border border-background-200/70 bg-background-50">
          <table className="w-full">
            <thead>
              <tr className="border-b border-background-200/70">
                <th className="px-6 py-4 text-left text-sm font-semibold text-foreground-500">Funktion</th>
                <th className="px-6 py-4 text-center text-sm font-semibold text-foreground-500">
                  OOPBuy Spreadsheet
                </th>
                <th className="px-6 py-4 text-center text-sm font-semibold text-foreground-500">
                  Normale Suche
                </th>
              </tr>
            </thead>
            <tbody>
              {[
                ['Struktur', '⭐⭐⭐⭐⭐', '⭐⭐'],
                ['Geschwindigkeit', 'Hoch', 'Niedrig'],
                ['Anfängerfreundlich', 'Ja', 'Nein'],
                ['Kategorienanzahl', '14+', 'Wenige'],
              ].map((row, idx) => (
                <tr key={idx} className="border-b border-background-200/70 last:border-b-0">
                  <td className="px-6 py-4 text-sm font-medium text-foreground-800">{row[0]}</td>
                  <td className="px-6 py-4 text-sm text-center text-accent-700 font-semibold bg-accent-50/30">
                    {row[1]}
                  </td>
                  <td className="px-6 py-4 text-sm text-center text-foreground-400">{row[2]}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}